export const LAST_ACTIVITY_STORAGE_KEY = 'mailbox.lastActivityAt';
export const SESSION_INACTIVITY_TIMEOUT_MS = 12 * 60 * 60 * 1000;

export function readLastActivityAt(): number | null {
  const raw = localStorage.getItem(LAST_ACTIVITY_STORAGE_KEY);
  if (!raw) return null;
  const parsed = Number(raw);
  if (!Number.isFinite(parsed) || parsed <= 0) return null;
  return parsed;
}

export function writeLastActivityAt(timestampMs: number = Date.now()): void {
  localStorage.setItem(LAST_ACTIVITY_STORAGE_KEY, String(timestampMs));
}

export function clearLastActivityAt(): void {
  localStorage.removeItem(LAST_ACTIVITY_STORAGE_KEY);
}

export function isSessionInactive(
  lastActivityAtMs: number | null,
  nowMs: number = Date.now(),
  timeoutMs: number = SESSION_INACTIVITY_TIMEOUT_MS
): boolean {
  if (!lastActivityAtMs || !Number.isFinite(lastActivityAtMs)) return false;
  return nowMs - lastActivityAtMs >= timeoutMs;
}

